export default __webpack_public_path__ + "static/media/graphStatistics.809fd26d.png";